/* eslint-disable complexity */
import {
  Component,
  OnInit,
} from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import {
  FILTER_MAP,
  REGION_FILTERS,
} from 'src/app/models/filter-details.model'
import { FiltersService } from 'src/app/services/filtersService.service'

@Component({
  selector: 'region-filter',
  templateUrl: './regionFilter.component.html',
  styleUrls: ['./regionFilter.component.scss'],
  providers: [],
})
export class RegionFilterComponent implements OnInit {

  // eslint-disable-next-line max-params
  constructor(
    private readonly filtersService: FiltersService,
  ) {}

  public readonly regionFilterLabels: string[] = REGION_FILTERS
  public readonly filterMap = FILTER_MAP
  public regionFilterGroup: UntypedFormGroup

  // eslint-disable-next-line max-statements
  ngOnInit() {
    this.regionFilterGroup = this.filtersService.activeFilters.region

    this.regionFilterGroup.valueChanges.subscribe(() => {
      this.filtersService.applyFilters()
    })


  }

}
